import { Button, ButtonGroup, Dialog, FormGroup, Input, TimePicker, Uploader } from '@tencent/spaui';
import useInput from '../../../leads_component/shared-components/hooks/useInput';
import MyInput from '../../common/maxLengthInput';
import MyTextArea from '../../common/maxLengthTextArea';
import React, { useState } from 'react';
import { genBasicHooks } from '../../../leads_component/shared-components/plugins/helper';
import {
  useInputCharLengthPlugin,
  useInputNumberRangePlugin,
} from '../../../leads_component/shared-components/plugins/input-plugins';
import useSelect from '../../../leads_component/shared-components/hooks/useSelect';
import Select from '../../common/Select';
import useTextArea from '../../../leads_component/shared-components/hooks/useTextArea';
import useTimePicker from '../../../leads_component/shared-components/hooks/useTimePicker';
import ImageSelectDialog from '../wechatMaterial/ImageSelectDialog';
import { RPCFactory } from '../../../utils/RequestUtil';

const UploaderInterval = Uploader.Uploader;
const WechatMessageTypeEnum = {
  TEXT: { value: 'TEXT', desc: '文本', key: 'text' },
  IMAGE: { value: 'IMAGE', desc: '图片', key: 'image' },
  IMAGE_TEXT: { value: 'IMAGE_TEXT', desc: '图文', key: 'imageText' },
};
const messageTypeData = [];
Object.keys(WechatMessageTypeEnum).forEach((key) => {
  messageTypeData.push({ value: key, label: WechatMessageTypeEnum[key].desc });
});

const MessageSendingRuleDialog = (props) => {
  const { tagList = [], wxAppId } = props || {};

  const [operating, setOperating] = useState(false);

  const getInit = (fieldName) => {
    if (!props.isEdit()) {
      return '';
    }
    if (props.editItem) {
      return props.editItem[fieldName] || '';
    }
  };
  const nameHooks = genBasicHooks(useInput, {
    value: getInit('ruleName'),
    required: true,
  }).usePlugin(useInputCharLengthPlugin, { maxLen: 20 });
  const tagSelectHooks = useSelect({
    data: tagList,
    value: () => {
      if (!props.isEdit()) {
        return '';
      }
      if (props.editItem) {
        return props.editItem.tagId == -1 ? '' : props.editItem.tagId;
      }
    },
    valid: true,
  });
  const noDisturbStartTimeHooks = useTimePicker({
    value: getInit('noDisturbStartTime'),
    valid: true,
    onChange: (e, value) => {
      calculateNoDisturbDuration(e, value, 'start');
    },
  });
  const noDisturbEndTimeHooks = useTimePicker({
    value: getInit('noDisturbEndTime'),
    valid: true,
    onChange: (e, value) => {
      calculateNoDisturbDuration(e, value, 'end');
    },
  });
  const hoursHooks = genBasicHooks(useInput, {
    value: props.isEdit() ? `${Math.floor(props.editItem.delaySeconds / 3600)}` : '0',
    required: true,
  }).usePlugin(useInputNumberRangePlugin, { min: -1 });
  const minutesHooks = genBasicHooks(useInput, {
    value: props.isEdit() ? `${Math.floor((props.editItem.delaySeconds / 60) % 60)}` : '0',
    required: true,
  }).usePlugin(useInputNumberRangePlugin, { min: -1, max: 59 });
  const secondsHooks = genBasicHooks(useInput, {
    value: props.isEdit() ? `${Math.floor(props.editItem.delaySeconds % 60)}` : '0',
    required: true,
  }).usePlugin(useInputNumberRangePlugin, { min: -1, max: 59 });

  const [messageType, setMessageType] = useState(
    props.isEdit() ? props.editItem.messageType : WechatMessageTypeEnum.TEXT.value,
  );
  const contentHooks = genBasicHooks(useTextArea, {
    value: () => {
      if (!props.isEdit()) {
        return '';
      }
      if (props.editItem) {
        if (messageType == WechatMessageTypeEnum.TEXT.value) {
          return props.editItem.text.content || '';
        }
      }
      return '';
    },
    required: true,
  }).usePlugin(useInputCharLengthPlugin, { maxLen: 1000 });
  const urlHooks = genBasicHooks(useInput, {
    value: () => {
      if (!props.isEdit()) {
        return '';
      }
      if (props.editItem) {
        return props.editItem[WechatMessageTypeEnum[messageType].key].url || '';
      }
      return '';
    },
    required: false,
  }).usePlugin(useInputCharLengthPlugin, { maxLen: 1000 });
  const titleHooks = genBasicHooks(useInput, {
    value: () => {
      if (!props.isEdit()) {
        return '';
      }
      if (props.editItem) {
        if (messageType == WechatMessageTypeEnum.IMAGE_TEXT.value) {
          return props.editItem.imageText.title || '';
        }
      }
      return '';
    },
    required: true,
  }).usePlugin(useInputCharLengthPlugin, { maxLen: 100 });
  const descHooks = genBasicHooks(useTextArea, {
    value: () => {
      if (!props.isEdit()) {
        return '';
      }
      if (props.editItem) {
        if (messageType == WechatMessageTypeEnum.IMAGE_TEXT.value) {
          return props.editItem.imageText.description || '';
        }
      }
      return '';
    },
    required: true,
  }).usePlugin(useInputCharLengthPlugin, { maxLen: 1000 });

  const [showImageSelectDialog, setShowDialog1] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [selectedImage, setSelectedImage] = useState({
    mediaId: !props.isEdit() ? '' : props.editItem[WechatMessageTypeEnum[messageType].key].mediaId || '',
    name: '',
    url: !props.isEdit() ? '' : props.editItem[WechatMessageTypeEnum[messageType].key].imageUrl || '',
    status: 'success',
  });

  const checkData = () => {
    // 一次性全检测，以免用户反复提交
    const name = nameHooks.checkValid();
    const hours = hoursHooks.checkValid();
    const minutes = minutesHooks.checkValid();
    const seconds = secondsHooks.checkValid();
    let text = true;
    let image = true;
    let imageText = true;
    if (messageType == WechatMessageTypeEnum.TEXT.value) {
      const content = contentHooks.checkValid();
      const url = urlHooks.checkValid();
      text = content && url;
    } else if (messageType == WechatMessageTypeEnum.IMAGE.value) {
      const mediaId = selectedImage.mediaId && selectedImage.mediaId != '';
      setErrorMessage(!mediaId ? '请选择/上传图片' : '');
      image = mediaId;
    } else {
      const title = titleHooks.checkValid();
      const desc = descHooks.checkValid();
      const url = urlHooks.checkValid();
      const mediaId = selectedImage.mediaId && selectedImage.mediaId != '';
      setErrorMessage(!mediaId ? '请选择/上传图片' : '');
      imageText = title && desc && url && mediaId;
    }
    return name && hours && minutes && seconds && text && image && imageText;
  };

  const handleSubmit = () => {
    if (!checkData()) {
      return;
    }
    let text;
    let image;
    let imageText;
    if (messageType == WechatMessageTypeEnum.TEXT.value) {
      text = {
        content: contentHooks.value,
        url: urlHooks.value,
      };
    } else if (messageType == WechatMessageTypeEnum.IMAGE.value) {
      image = {
        mediaId: selectedImage.mediaId,
      };
    } else {
      imageText = {
        title: titleHooks.value,
        description: descHooks.value,
        url: urlHooks.value,
        mediaId: selectedImage.mediaId,
      };
    }
    const postData = {
      ruleName: nameHooks.value,
      tagId: tagSelectHooks.props.value || -1,
      eventType: 1,
      noDisturbStartTime: noDisturbStartTimeHooks.props.value || '',
      noDisturbEndTime: noDisturbEndTimeHooks.props.value || '',
      delaySeconds: Number(hoursHooks.value) * 3600 + Number(minutesHooks.value) * 60 + Number(secondsHooks.value),
      messageType,
      text,
      image,
      imageText,
    };

    if (props.isEdit()) {
      postData.ruleId = props.editItem.ruleId;
    }
    setOperating(true);

    let promise;
    if (!props.isEdit()) {
      promise = RPCFactory.messageSendingRule.add;
    } else {
      promise = RPCFactory.messageSendingRule.update;
    }

    promise(wxAppId, postData)
      .done(() => {
        props.onSuccess();
      })
      .fail((code, msg) => {
        alert(msg);
      })
      .always(() => {
        setOperating(false);
      });
  };

  const imageFormGroup = () => {
    const uploader = (
      <UploaderInterval
        className="upimgbtn"
        accept="image/bmp,image/png,image/jpeg,image/jpg,image/gif"
        name="file"
        style={{ marginTop: '10px' }}
        headers={{ 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }}
        url={`/api/v1/wechat_material/add_image?accountId=${window.pageProps.uid}&wxAppId=${wxAppId}&csrfToken=${window.pageProps.token}`}
        value={selectedImage}
        onUpload={() => {
          setOperating(true);
        }}
        onComplete={(err, xhr, response = {}, fileInfo = {}, fileId) => {
          const { data } = response;
          if (response.code == 0) {
            setSelectedImage({ mediaId: data.mediaId, name: fileInfo.name, url: data.url, status: 'success' });
            setErrorMessage('');
          } else {
            setErrorMessage(response.msg);
          }
          setOperating(false);
        }}
      >
        <label className="upimgbtn">本地上传</label>
      </UploaderInterval>
    );

    if (selectedImage.mediaId == '') {
      return (
        <FormGroup>
          <div className="imgup">
            <div className="flex">
              <div className="upbtn">
                <a
                  className="upimgbtn"
                  onClick={() => {
                    setShowDialog1(true);
                  }}
                >
                  选择历史图片
                </a>
                {uploader}
              </div>
              <p className="imgupbg">上传图片，仅支持bmp/png/jpeg/jpg/gif格式，大小不超过10M</p>
            </div>
          </div>
        </FormGroup>
      );
    }
    return (
      <FormGroup>
        <div className="imgup imguped">
          <div className="flex">
            <img src={selectedImage.url} title={selectedImage.name} />
          </div>
          <div className="reup">
            <div className="flex">
              <div className="upbtn">
                <a
                  className="upimgbtn"
                  onClick={() => {
                    setShowDialog1(true);
                  }}
                >
                  选择历史图片
                </a>
                {uploader}
              </div>
            </div>
          </div>
        </div>
      </FormGroup>
    );
  };

  const getHourDiff = (start, end) => {
    if (start != null && start != '' && end != null && end != '') {
      const startDate = new Date(`1970/01/01 ${start}`);
      const endDate = new Date(`1970/01/01 ${end}`);
      if (startDate.getTime() >= endDate.getTime()) {
        endDate.setDate(endDate.getDate() + 1);
      }
      return (endDate.getTime() - startDate.getTime()) / 3600000;
    }
    return null;
  };

  const [exceed12hours, setExceed12hours] = useState(() => {
    const hourDiff = getHourDiff(noDisturbStartTimeHooks.props.value, noDisturbEndTimeHooks.props.value);
    return hourDiff != null && hourDiff > 12;
  });
  const calculateNoDisturbDuration = (event, value, type) => {
    let start;
    let end;
    if (type == 'start') {
      start = value;
      end = noDisturbEndTimeHooks.props.value;
    } else if (type == 'end') {
      start = noDisturbStartTimeHooks.props.value;
      end = value;
    }
    const hourDiff = getHourDiff(start, end);
    setExceed12hours(hourDiff != null && hourDiff > 12);
  };

  return (
    <Dialog
      backdrop
      hideFooter
      type="normal"
      className="modal-set-height"
      title={!props.isEdit() ? '新建被回复消息' : '编辑被回复消息'}
      style={{ width: '580px' }}
      {...props.props}
    >
      <div className="message-setting form-list-normal">
        <div className="lump lump-nohd">
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <span className="info-tt">消息名称</span>
                <div className="info-des">
                  <MyInput placeholder="请输入规则名称" {...nameHooks.props} />
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt info-tt-read">回复对象</span>
                <div className="info-des">
                  <FormGroup>
                    <Select
                      clear
                      placeholder="全部"
                      valueFieldName={'tagId'}
                      labelFieldName={'tagName'}
                      {...tagSelectHooks.props}
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">免打扰时间</span>
                <div className="info-des">
                  <div className="flex">
                    <TimePicker clear {...noDisturbStartTimeHooks.props} />
                    <span className="sp-hor"></span>
                    <TimePicker
                      clear
                      formGroupProps={
                        !noDisturbStartTimeHooks.props.value ||
                        noDisturbStartTimeHooks.props.value == '' ||
                        !noDisturbEndTimeHooks.props.value ||
                        noDisturbEndTimeHooks.props.value == '' ||
                        noDisturbStartTimeHooks.props.value < noDisturbEndTimeHooks.props.value
                          ? {}
                          : { prefix: <span>次日</span> }
                      }
                      {...noDisturbEndTimeHooks.props}
                    />
                  </div>
                  {exceed12hours && <div className="warning-text">您设定的免打扰时间超过12小时</div>}
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">发送延迟时间</span>
                <div className="info-des">
                  <div className="flex timec">
                    <Input {...hoursHooks.props} />
                    <span className="unit">小时</span>
                    <Input {...minutesHooks.props} />
                    <span className="unit">分</span>
                    <Input {...secondsHooks.props} />
                    <span className="unit">秒</span>
                  </div>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">消息内容</span>
                <div className="info-des">
                  <ButtonGroup
                    data={messageTypeData}
                    value={messageType}
                    onChange={(event, value, buttonProps) => {
                      setMessageType(value);
                    }}
                    disabled={props.isEdit()}
                  />
                  {messageType == WechatMessageTypeEnum.TEXT.value && (
                    <div className="infogroup">
                      <MyTextArea placeholder="请输入文字内容" {...contentHooks.props} />
                      <MyInput placeholder="请输入链接（选填）" {...urlHooks.props} />
                    </div>
                  )}
                  {messageType == WechatMessageTypeEnum.IMAGE.value && (
                    <div className="infogroup">
                      {imageFormGroup()}
                      {errorMessage !== '' && <div className="error-text">{errorMessage}</div>}
                    </div>
                  )}
                  {messageType == WechatMessageTypeEnum.IMAGE_TEXT.value && (
                    <div className="infogroup">
                      <MyInput placeholder="请输入标题" {...titleHooks.props} />
                      <MyTextArea placeholder="请输入描述" {...descHooks.props} />
                      <MyInput placeholder="请输入链接（选填）" {...urlHooks.props} />
                      {imageFormGroup()}
                    </div>
                  )}
                </div>
              </li>
            </ul>
          </div>

          {showImageSelectDialog && (
            <ImageSelectDialog
              show={showImageSelectDialog}
              wxAppId={wxAppId}
              value={selectedImage.mediaId}
              setShow={setShowDialog1}
              onSubmit={(image) => {
                setSelectedImage({
                  mediaId: image.mediaId,
                  name: image.name,
                  url: image.url,
                  status: 'success',
                });
                setErrorMessage(image.mediaId == '' ? '请选择/上传图片' : '');
              }}
            />
          )}
        </div>
        <div className="btnline" style={{ 'padding-left': '170px', 'margin-top': '0px' }}>
          <Button displayType="default" onClick={props.onCancel}>
            取消
          </Button>
          <Button displayType="primary" onClick={handleSubmit} disabled={operating}>
            确定
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default MessageSendingRuleDialog;
